var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.64 11.868a1 1 0 0 1 .993.883l.007.117v3.92a2.96 2.96 0 0 1-2.786 2.955l-.174.005H2.96a2.96 2.96 0 0 1-2.955-2.786L0 16.788v-3.92a1 1 0 0 1 1.993-.117l.007.117v3.92c0 .492.37.898.848.953l.112.007h13.72a.96.96 0 0 0 .954-.848l.006-.112v-3.92a1 1 0 0 1 1-1zM9.82.108a1 1 0 0 1 .993.883l.007.117v9.343l3.193-3.19a1 1 0 0 1 1.32-.083l.094.083a1 1 0 0 1 .083 1.32l-.083.094-4.9 4.9a1.006 1.006 0 0 1-.09.08l.09-.08a1.008 1.008 0 0 1-.674.292h-.065l-.054-.003.086.004a1.008 1.008 0 0 1-.613-.21 1.037 1.037 0 0 1-.094-.083l-4.9-4.9a1 1 0 0 1 1.32-1.497l.094.083 3.193 3.192V1.108a1 1 0 0 1 1-1z",
    fill: "#587E85",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.c34c8fe2ea9896ba215bfcb3b572996c.svg";
export { ForwardRef as ReactComponent };